import settings from '../../assets/settings.json';
import Cookies from 'js-cookie'



class FunctionFields {

  addJanData(what_type, tr_elems, dataArray){
    for (let i = 0; i < tr_elems.length; i++) {
      let jan = null;
      if(i<2){
        continue;
      }

      for (let ii = 0; ii < dataArray.length; ii++) {
        if(dataArray[ii].order_key===tr_elems[i].childNodes[22].innerText){
          tr_elems[i].childNodes[35].innerText = dataArray[ii].JAN;
          break;
        }
      }
    }

    console.dir(tr_elems);

    return tr_elems;
  }




  postChangeDataStatus(key_array, auth_obj, new_status){
    fetch(settings.API_BASE_URL+'change_data_cm_data/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name +'&what=hattyuu_status_now&new_status='+new_status , {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({"data":key_array})
    })
    .then(response => response.json())
    .then(data => {
      console.dir(data);
      alert('データを変更しました');
    })
    .catch(error => {
      console.error(error);
      alert(error);
    });


  }

  changeDataStatus(tr_elems, new_status, __data, __data_fix){
    let index = 0;
    let key_array = [];
    if(new_status==='完了'){
      index =1
    }
    for (let i = 0; i < tr_elems.length; i++) {
      if(i<2){
        continue;
      }
      let key = tr_elems[i].childNodes[index].innerText;
      if(key!==NaN && key!==''){
        key_array.push(key);
      }
    }

    console.dir(key_array);

    for (let i = 0; i < key_array.length; i++) {
      for (let ii = 0; ii < __data.length; ii++) {
        if(key_array[i]===__data[ii].order_key){
          __data[ii].hattyuu_status_now = new_status;
          __data[ii].cm_item_name = '管理的変更_'+new_status+'_'+__data[ii].cm_item_name;
          break;
        }
      }

      for (let iii = 0; iii < __data_fix.length; iii++) {
        if(key_array[i]===__data_fix[iii].order_key){
          __data_fix[iii].hattyuu_status_now = new_status;
          __data_fix[iii].cm_item_name = '管理的変更_'+new_status+'_'+__data_fix[iii].cm_item_name;
          break;
        }
      }
    }

    return [__data, __data_fix, key_array];
  }


  checkYoyakuKeppin(hikiate_zero_id_array, __data, __data_fix, dataFixIdArray){
    console.dir(hikiate_zero_id_array);
    for (let i = 0; i < hikiate_zero_id_array.length; i++) {
      for (let index = 0; index < __data.length; index++) {
        if( hikiate_zero_id_array[i]===__data[Number(index)].id){
          let this_db_id = __data[index].id;
          let index_at_fix_data = dataFixIdArray.indexOf(this_db_id);
          __data[Number(index)].cm_item_name = __data[Number(index)].cm_item_name.replace('予約注文___', '予約注文欠品___');
          __data_fix[index_at_fix_data].cm_item_name = __data_fix[index_at_fix_data].cm_item_name.replace('予約注文___', '予約注文欠品___');
          console.log('change 予約欠品 '+__data[index].order_key);
          break;
        }
      }
    }

    return [__data, __data_fix]
  }



  researveItem(_jan, _val, __data, __data_fix, dataFixIdArray, what_type, _i){
    let count = 0;
    //for (let index = 0; index < __data.length; index++) {
    for (var index = __data.length - 1; index >= 0 ; index--){ //下からループしている
      console.dir(__data[Number(index)]);
      if(__data[index].JAN===_jan && __data[Number(index)].cm_item_name.indexOf('予約注文欠品___') === -1){
        if(count===_i){
          let this_db_id = __data[index].id;
          let index_at_fix_data = dataFixIdArray.indexOf(this_db_id);
          __data[Number(index)].cm_item_name = '予約注文___'+__data[Number(index)].cm_item_name;
          __data_fix[index_at_fix_data].cm_item_name = '予約注文___'+ __data_fix[index_at_fix_data].cm_item_name;
          console.log('change 予約名前 '+_jan);
          break;
        }
        count = count + (__data[Number(index)].hattyuu_zumi - __data[Number(index)].hikiate_howmany) ;
        //console.log(count);
      }
    }

    
    return [__data, __data_fix]
  }





  // エトワール
  soartTable(tr_elems, select_label, dataArray){
    console.log('ソート');
    console.dir(dataArray);
    let re_array = [];
    let hattyuu_jan_array = [];

    for (let i = 0; i < tr_elems.length; i++) {
      console.dir(tr_elems[i]);
      let _jan = '';
      let isit_hit = false;
      let isit_yoyaku_bun = false;

      if(tr_elems[i].childNodes[1].childNodes[0].innerText===''){
        continue;
      }

      for (let ii = 0; ii < dataArray.length; ii++) {
        _jan = dataArray[ii].JAN;
        let _item_type = dataArray[ii].item_type;
        //_item_type = _item_type.replace(' ','-');
        
        if(_item_type===tr_elems[i].childNodes[1].childNodes[0].innerText){
          console.log('HIT JAN '+_jan+' '+_item_type);
          isit_hit = true;
          break;
        }
      }

      if(isit_hit===false){
        continue;
      }



      console.dir(dataArray);
      for (let ii = 0; ii < dataArray.length; ii++) {
        if(_jan === dataArray[ii].JAN){

          if(dataArray[ii].cm_item_name.indexOf('予約注文___01')!==-1 ){
            isit_yoyaku_bun=true;
          }

          // 注文した数である hikiate_howmany をチェック
          var _hikiate_how = dataArray[ii].hikiate_howmany;
          if(_hikiate_how===''){
            _hikiate_how = 0;
          }
          let jan_obj = {};
          console.dir(dataArray[ii]);
          if(hattyuu_jan_array.length===0){
            jan_obj[_jan] = dataArray[ii].hikiate_howmany;
            jan_obj['item_type'] = dataArray[ii].item_type;
            jan_obj['key'] = dataArray[ii].order_key;
            jan_obj['when_syukka'] = dataArray[ii].when_syukka;
            console.dir(jan_obj);
            
            hattyuu_jan_array.push( jan_obj );
            console.log('PUSH 1');
          }else{
            let isit_in_array = false;
            let which_i = 0;
            for (let i = 0; i < hattyuu_jan_array.length; i++) {
              if(hattyuu_jan_array[i].hasOwnProperty(_jan)){
                //hattyuu_jan_array[i][data.JAN] = hattyuu_jan_array[i][data.JAN] +  _hikiate_how;
                isit_in_array = true;
                which_i = i;
                break;
              }else{
                isit_in_array = false;
              }
            }

            if(isit_in_array===true){
              hattyuu_jan_array[which_i][_jan] = hattyuu_jan_array[which_i][_jan] +  _hikiate_how;
              console.dir(dataArray[ii]);
              console.log('ADD COUNT');
            }else{
              jan_obj[_jan] = _hikiate_how;
              jan_obj['item_type'] = dataArray[ii].item_type;
              jan_obj['key'] = dataArray[ii].order_key;
              jan_obj['when_syukka'] = dataArray[ii].when_syukka;
              hattyuu_jan_array.push( jan_obj );
              console.log('PUSH 2');
            }
          }
        }
      }

      console.dir(hattyuu_jan_array);

      let _val = 0;
      {hattyuu_jan_array.map((data_obj, index)=>{
        //console.dir(data_obj);

        let count = 0;
        let __jan = '';
        let _item_type = '';
        let _when_syukka = '';
        for (const [key, value] of Object.entries(data_obj)) {
          if(count===0){
            __jan = key;
            _val = value;
          }else if(key==='item_type'){
            _item_type = value;
          }else if(key==='when_syukka'){
            _when_syukka = value;
          }
          count++;
        }
      })}



      let _inner_text = tr_elems[i].childNodes[4].innerText;

      if(isit_yoyaku_bun===true){
        tr_elems[i].childNodes[4].innerText = '(予約注文の返事含む)';
      }

      if(_inner_text!==''){
        let _obj = {};
        _obj['key'] = _inner_text; 
        _obj['val'] = [
          tr_elems[i].childNodes[1].childNodes[0].innerText,// 品番
          tr_elems[i].childNodes[2].childNodes[0].innerText,// 名称
          _jan,
          _val,//注文数
          tr_elems[i].childNodes[3].childNodes[0].innerText,//不足
          tr_elems[i].childNodes[4].innerText//エトワールからの納期
        ]
        re_array.push(_obj);
      }
    }

    console.dir(re_array);

    //ソート
    let re_tr_elems = re_array.sort(function(a, b) {
      return (a.key < b.key) ? -1 : 1;  //オブジェクトの昇順ソート
    });

      

    //}

    console.dir(re_tr_elems);

    //let sheet_data_obj_array = [];
    //for (let i = 0; i < tr_elems.length; i++) {
    //  if(i<1){
    //    continue;
    //  }
    //}




    return re_tr_elems;
  }



  getTrElems(){
    let tr_elems = document.getElementsByClassName('paste-table etoile-table')[0].childNodes[0].childNodes[1].childNodes;
    return tr_elems;
  }




  getCmDataIds(__data){
    let id_array = [];
    for (let index = 0; index < __data.length; index++) {
      let this_db_id = String(__data[index].id);
      id_array.push(this_db_id);
    }

    return id_array;
  }





  getDataIndex(tr_elems, select_label){
    let jan_index = 0;
    let hikiate_howmany_index = 0;
    let sheet_data_obj_array = [];
    let fusoku_howmany_index = 0;
    let reserve_jan_array = [];
    

    for (let i = 0; i < tr_elems.length; i++) {
      if(i<2){
        continue;
      }
      //console.dir(tr_elems[i]);

      if(select_label==='出荷確認：阿部玩具さん貼り付け'){
        jan_index = 1;
        hikiate_howmany_index = 5;
      }else if(select_label==='出荷確認：マルクさん貼り付け'){
        jan_index = 4;
        hikiate_howmany_index = 6;
      }else if(select_label==='出荷確認：エトワールさんメール返事分の貼り付け'){
        jan_index = 3;
        hikiate_howmany_index = 4;
        fusoku_howmany_index = 5;
      }else if(select_label==='出荷確認：介援隊さん貼り付け'){
        jan_index = 35;
        hikiate_howmany_index = 18;
      }else{
        console.log('select_label:'+select_label);
      }

      //console.log('jan_index:'+String(jan_index)+' hikiate_howmany_index:'+String(hikiate_howmany_index));

      //
      let jan = tr_elems[i].childNodes[jan_index].innerText;
      let hikiate_howmany_t = Number(tr_elems[i].childNodes[hikiate_howmany_index].innerText);
      let fusoku_howmany_t = 0;
      let reserve_jan_obj = {};
      if(select_label==='出荷確認：エトワールさんメール返事分の貼り付け'){
        fusoku_howmany_t = Number(tr_elems[i].childNodes[fusoku_howmany_index].innerText);
        let result = tr_elems[i].childNodes[7].innerText;
        if(result==='再発注！' || result==='再発注？'){
          //fusoku_howmany_t = 0;

          // 予約注文したけど再度延期やキャンセルの場合、ここでは何もしなくていいかな



          // すぐに発注する
          reserve_jan_obj[jan] = fusoku_howmany_t;
          reserve_jan_array.push(reserve_jan_obj);
          hikiate_howmany_t = hikiate_howmany_t-fusoku_howmany_t;
        }else if(result.indexOf('引き当てゼロ') !== -1){
          hikiate_howmany_t = hikiate_howmany_t-fusoku_howmany_t;
        }
      }

      if(jan===''){
        continue;
      }
      
      //console.dir(jan);
      //console.dir(hikiate_howmany_t);
      //console.dir(fusoku_howmany_t);
      //hikiate_howmany_t = hikiate_howmany_t - fusoku_howmany_t;
      //console.dir(hikiate_howmany_t);

      let _which = '';
      let jan_obj = {};
      if(sheet_data_obj_array.length===0){
        _which = '0';
        jan_obj[jan] = hikiate_howmany_t;
        //console.dir(jan_obj);
        sheet_data_obj_array.push(jan_obj);
        //console.log('PUSH');
        //console.dir(sheet_data_obj_array);
      }else{
        console.log('how_long:'+String(sheet_data_obj_array.length));
        for (let ii = 0; ii < sheet_data_obj_array.length; ii++) {
          if(sheet_data_obj_array[ii].hasOwnProperty(jan)){
            sheet_data_obj_array[ii][jan] = sheet_data_obj_array[ii][jan] + hikiate_howmany_t;
            _which = '1';
          }else{
            jan_obj[jan] = hikiate_howmany_t;
            //console.dir(jan_obj);
            sheet_data_obj_array.push(jan_obj);
            //console.log('PUSH');
            //console.dir(sheet_data_obj_array);
            _which = '2';
            break;
          }
        }
      }

      //console.log('_which '+_which);
      

    }

    console.dir(sheet_data_obj_array);
    console.dir(reserve_jan_array);


    return [sheet_data_obj_array, reserve_jan_array ];
  }
  
}

const addPartsFunction = new FunctionFields();

export { addPartsFunction };